import React, { useState } from "react";
import { Button, Flex, Textarea, toast } from "@jsq/ds/core";
import { useCreateComplianceCaseCommentMutation } from "~/graphql/supergraphHooks";
import * as styles from "./styles_vanilla.css";

interface Props {
  caseId: number;
  isInternalComment: boolean;
  commentTypeToggle: React.ReactNode;
}

const CommentInput: React.FC<Props> = ({
  caseId,
  isInternalComment,
  commentTypeToggle,
}: Props) => {
  const [commentText, setCommentText] = useState("");
  const [saveCommentMutation] = useCreateComplianceCaseCommentMutation({
    refetchQueries: ["GetComplianceCaseAuditLogs"],
    onError: (e) => {
      toast.error(e.message);
      throw e;
    },
  });
  const handleSaveComment = async () => {
    try {
      await saveCommentMutation({
        variables: {
          comment: commentText,
          format: "text",
          objectType: "case",
          objectId: caseId,
          internal: isInternalComment,
        },
      });
      setCommentText("");
    } catch {
      // do nothing
    }
  };
  return (
    <Flex flexDirection={"column"} flexGrow={1}>
      <Textarea
        name="complainceCaseLogComment"
        placeholder="Write a comment"
        isFullWidth
        onSetValue={(value) => setCommentText(value)}
        value={commentText}
        data-testid="complainceCaseLogComment"
        data-cy="complainceCaseLogComment"
      />
      <Flex justifyContent={"space-between"} className={styles.actionsRow} gap={12}>
        {commentTypeToggle}
        <Button
          variant="primary"
          onClick={handleSaveComment}
          disabled={commentText.length === 0}
          data-testid="complainceCaseLogCommentSaveButton"
          data-cy="complainceCaseLogCommentSaveButton"
        >
          Save
        </Button>
      </Flex>
    </Flex>
  );
};

export default CommentInput;
